import { clsx } from '@libs/common-next';

import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps } from './types';
import './Tile6UpPromo.scss';

export default function Tile6UpPromo({ header, tiles, variant }: Tile6UpProps) {
    const classNames = clsx('tile6up-promo', tiles.length < 6 && 'xl-even-spacing');

    return (
        <BuildContextProvider>
            <SixTileCarousel
                className={classNames}
                alignText="left"
                data-testid="six-tile-promo"
                header={header}
                tiles={tiles}
                variant={variant}
                overrideDefaultClass
            />
        </BuildContextProvider>
    );
}
